import React, { Suspense, lazy } from "react";
import { ToastContainer } from "react-toastify";

import Sentry from "utils/sentry";
import "./style.scss";

import Snowfall from "components/Snowfall";
import ErrorBoundary from "containers/ErrorBoundary";
import Masks from "./Masks";

const Routing = lazy(() => import("containers/Routing"));
const UserProvider = lazy(() => import("components/UserProvider"));
const MiscProvider = lazy(() => import("components/MiscProvider"));
const LocalesProvider = lazy(() => import("components/LocalesProvider"));
const EventProvider = lazy(() => import("components/EventProvider"));

export default function App() {
  return (
    <Suspense fallback={null}>
      <ErrorBoundary>
        <MiscProvider>
          <UserProvider>
            <EventProvider>
              <LocalesProvider>
                <Routing />
              </LocalesProvider>
            </EventProvider>
          </UserProvider>
        </MiscProvider>

        <Masks />
        <Snowfall />
        <ToastContainer
          newestOnTop
          autoClose={2500}
        />
      </ErrorBoundary>
    </Suspense>
  );
};
